<template>
  <div>
    <v-row v-if="this.isAdmin" cols="12" sm="12" md="12" lg="12" class="row-menu-right mb-3 pr-3" style="margin-top: -50px;">
      <v-btn
        v-if="mode=='approve'"
        outlined
        class="button-color-outline head-search-button mr-1"
        :disabled="!allowBtnReject"
        @click="clickReject()"
      >
      {{ textBtnNO }}
      </v-btn>
      <v-btn
        class="button-color head-search-button ml-1 white--text text--lighten-4"
        elevation="0"
        :disabled="!allowBtnApprove"
        @click="clickApprove()"
      >
      {{ textBtnOk }}
      </v-btn>
    </v-row>
    <OverlayLoading :loading="loading" />
    <div>
      <v-data-table
        class="border-table-employee text-no-wrap table-approve"
        item-key="_id"
        v-model="selected"
        :headers="headers"
        :items="dataSource"
        :loading="loading"
        loader-height=0
        loading-text="Loading... Please wait"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100, -1],
          'items-per-page': 15
        }"
        :server-items-length="total || -1"
        @update:items-per-page="changePerPage"
        @update:page="changePage"
        :single-select="singleSelect"
        :show-select="this.isAdmin"
        @input="checkAllowBtn()"
        @toggle-select-all="selectAllToggle"
        disable-sort
      >
        <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
          <v-checkbox
            v-if="item.status==='pending' && isAdmin"
            v-show="true"
            v-model="item.selected"
            :value="isSelected"
            hide-details
            class="ma-0"
            style="width: 0px;"
            @change="select($event)"
          />
        </template>
        <template v-slot:[`item.no`]="{ item }">
          {{ (perPage*(page-1)) + dataSource.indexOf(item)+1 }}
        </template>
        <template v-slot:[`item.updateAt`]="{ item }">
          {{ item.updateAt }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip
            :color="['approve','acknowledge'].includes(item.status)? '#ECF8EA': ['reject','cancel'].includes(item.status)? '#FBE5E4':'#ECF9FF'"
            :text-color="statusList.filter(e => e.status === item.status)[0].color"
          >
            <span>{{ statusList.filter(e => e.status === item.status)[0].statusTH || '-' }}</span>
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                rounded
                icon
                tile
                class="ra-border-button mr-2"
                @click="view(item)"
              >
              <v-icon dark color="primary" >mdi-file-eye</v-icon>
              </v-btn>
            </template>
            <span class="label-table-action">ดูรายละเอียด</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </div>
    <!-- <DialogShowDetail/> -->
    <v-dialog
      v-model="dialog"
      persistent
      max-width="344"
      max-height="232"
    >
      <v-card tile class="justify-center">
        <v-card-title class="justify-center">
          <span style="font-family: Sarabun; font-style: normal; font-weight: bold; font-size: 16px; line-height: 22px; text-align: center; color: #3776E9;">
            {{ mode=='approve'? workfor=='approve'? 'ต้องการอนุมัติคำร้องใช่ไหม':'ต้องการไม่อนุมัติคำร้องใช่ไหม':'ต้องการรับทราบคำร้องใช่ไหม' }}
          </span>
        </v-card-title>
        <v-card-subtitle class="layout justify-center pt-1">
          <span style="font-family: Sarabun; font-style: normal; font-weight: 400; font-size: 16px; line-height: 22px; text-align: center; color: #757575; margin-top: 12px;">
            {{ mode=='approve'? workfor=='approve'? 'คุณแน่ใจหรือไม่ว่าต้องการอนุมัติคำร้อง':'คุณแน่ใจหรือไม่ว่าไม่ต้องการอนุมัติคำร้อง':'คุญแน่ใจหรือไม่ว่าต้องการรับทราบคำร้อง' }}
          </span>
        </v-card-subtitle>
        <v-textarea v-model="comment" class="ml-8 mr-8" outlined rows="2" placeholder="ระบุความเห็น" v-if="mode=='approve'"></v-textarea>
        <v-card-actions class="justify-center pb-4">
           <v-btn
              color="primary"
              outlined
              class="head-search-button mr-4"
              width="83"
              @click="dialog = false"
            >
            ยกเลิก
            </v-btn>
            <v-btn
              color="primary"
              class="head-search-button ml-4 white--text text--lighten-4"
              elevation="0"
              width="83"
              @click="updateStatusApprove(workfor, mode, comment)"
            >
            ยืนยัน
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogRegisterCompany" max-width="500px" persistent>
      <v-card height="180px">
        <v-card-title class="ra-head-text-bold justify-center pa-5">คุณยังไม่มีการร้องขอการลงทะเบียนบริษัท</v-card-title>
        <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center" style="font-size: 16px;">กรุณาลงทะเบียนบริษัทก่อน</span>
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="ra-button1" color="#1654C6" dark @click="$router.push('/manageapprovecompany/create')">กดเพื่อไปยังหน้าลงทะเบียนบริษัท</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
          <v-spacer></v-spacer>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :timeout="2000"
      top
      centered
      elevation="1"
      color="#ECF8EA"
      app
    >
      <v-icon dark color="#58A144" >mdi-check-circle-outline</v-icon>
      <span style="font-family: Sarabun; font-style: normal; font-weight: 400; font-size: 16px; line-height: 22px; text-align: center; color: #58A144;">
        {{ workfor=='approve'? 'คุณได้ทำการอนุมัติคำร้องเรียบร้อย':'คุณได้ทำการไม่อนุมัติคำร้องเรียบร้อย' }}
      </span>
    </v-snackbar>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import OverlayLoading from '../../_template/OverlayLoading.vue'
import { fetchAllRequestApproveCompany } from '@/API/API'
const swal = require('sweetalert')
const axios = require('axios')
const moment = require('moment')
export default {
  name: 'tree',
  components: {
    OverlayLoading
  },
  props: {
    mode: String
  },
  data () {
    return {
      dialog: false,
      dialogRegisterCompany: false,
      workfor: 'approve',
      comment: '',
      snackbar: false,
      // isAdmin: localStorage.approveRole === 'Super Admin' ? localStorage.approveRole === 'Super Admin' : false,
      isAdmin: this.$store.state.user.role[1].permission === 'Super Admin' ? this.$store.state.user.role[1].permission === 'Super Admin' : false,
      singleSelect: false,
      allowBtnApprove: false,
      allowBtnReject: false,
      loading: false,
      filterData: {
        reqEmployeeNo: '',
        employeeName: '',
        companyName: [],
        position: [],
        requestType: [],
        requestStatus: [],
        approveType: this.mode,
        limit: 15,
        page: 1
      },
      textBtnOk: this.mode === 'approve' ? 'อนุมัติ' : 'รับทราบ',
      textBtnNO: this.mode === 'approve' ? 'ไม่อนุมัติ' : 'ไม่รับทราบ',
      statusList: [
        { status: 'pending', statusTH: 'กำลังดำเนินการ', color: '#00B0FF' },
        { status: 'approve', statusTH: 'อนุมัติแล้ว', color: '#58A144' },
        { status: 'reject', statusTH: 'ไม่อนุมัติ', color: '#D1392B' },
        { status: 'cancel', statusTH: 'ยกเลิก', color: '#D1392B' },
        { status: 'acknowledge', statusTH: 'รับทราบแล้ว', color: '#58A144' }
      ],
      headers: [
        {
          text: 'ลำดับ',
          align: 'left fixed',
          value: 'no',
          width: '70px',
          groupable: false,
          sortable: false,
          class: 'column-fix'
        },
        { text: 'หมายเลขคำร้อง', value: 'reqCompanyNo', divider: true, align: 'left fixed', class: 'column-fix' },
        { text: 'ชื่อ-นามสกุล', value: 'userFullNameTh' },
        { text: 'บริษัท', value: 'companyName' },
        { text: 'เวลาที่ร้องขอ', value: 'createAt' },
        { text: 'สถานะคำร้อง', value: 'status', width: '15%' },
        { text: '', align: 'right', width: '5%', value: 'actions', sortable: false }
      ],
      checkBtnRehister: false,
      selected: [],
      dataSource: [],
      serviceTypeList: [],
      requestStatusList: [],
      total: -1,
      perPage: 15,
      page: 1,
      textCondition: {
        new: 'เพิ่มบุคคล',
        transfer: 'ขอย้ายฝ่าย',
        resign: 'ขอลาออก',
        transferPosition: 'ย้ายตำแหน่ง',
        resignPosition: 'ลาออกจากตำแหน่ง',
        resignEmployee: 'ลาออกจากบริษัท'
      }
    }
  },
  async created () {
    // console.log('test', this.isAdmin)
    // await this.searchFilterData(this.filterData)
    // this.isAdmin = this.$store.state.user.role[1].permission === 'Super Admin'
    this.loading = true
  },
  beforeDestroy () {
    EventBus.$off('openDialogManageApprove')
    EventBus.$off('manageApproveComSearch')
    this.loading = false
  },
  mounted () {
    EventBus.$on('manageApproveComSearch', this.setFilter)
  },
  methods: {
    changePerPage (value) {
      this.perPage = value
      this.setFilter(this.filterData)
    },
    changePage (value) {
      this.page = value
      this.setFilter(this.filterData)
    },
    async setFilter (value) {
      this.filterData = value
      var searchPayload = {
        companyName: this.filterData.companyName || [],
        groupCompanyName: this.filterData.groupCompanyName || [],
        // position: this.filterData.position || [],
        reqCompanyNo: this.filterData.reqCompanyNo || '',
        // requestType: this.filterData.requestType || [],
        role: this.filterData.role,
        userFullNameTh: this.filterData.searchNameAndEmpId || '',
        status: this.filterData.status || [''],
        tab: this.filterData.tab,
        limit: this.perPage,
        page: this.page
      }
      this.searchFilterData(searchPayload)
    },
    async searchFilterData (value) {
      const self = this
      self.loading = true
      self.selected = []
      self.filterData = value
      self.isAdmin = localStorage.approveRole === 'Super Admin'
      try {
        const res = await fetchAllRequestApproveCompany(value, this.$store.state.token)
        if (res.success) {
          self.total = res.count || -1
          EventBus.$emit('updateTotalCom', {
            totalAll: res.totalAll,
            totalApproved: res.totalApproved,
            totalPending: res.totalPending,
            totalRejected: res.totalRejected,
            totalWaiting: res.totalWaiting
          })
          self.total = res.total || -1
          if (self.total + 1 === 0 && !self.isAdmin) {
            this.dialogRegisterCompany = true
          }
          self.dataSource = res.result || []
          self.computeData(self.dataSource)
          EventBus.$emit('checkBtnRegister', res.checkReq)
        } else {
          self.dataSource = []
        }
      } catch (error) {
        console.log(error)
        self.dataSource = []
      } finally {
        self.loading = false
      }
    },
    async computeData (item) {
      await item.map(e => {
        e.createAt = moment(e.createAt).format('DD/MM/YYYY HH:mm น.')
      })
    },
    // async updateAcknowledge (listId) {
    //   var obj = {
    //     acknowledgeList: listId
    //   }
    //   // console.log(obj)
    // },
    view (item) {
      // console.log(item)
      // EventBus.$emit('openDialogManageApprove', this.filterData.role, item)
      this.$router.push('manageapprovecompany/update/' + item._id)
    },
    createRequestService () {
      // console.log('createRequestService')
      // this.$router.push('/authorityservices/requestservicelist/create')
      this.$router.push('/authorityservices/myservicelist/create')
    },
    checkAllowBtn () {
      if (this.selected.length > 0) {
        this.allowBtnApprove = true
        this.allowBtnReject = true
      } else {
        this.allowBtnApprove = false
        this.allowBtnReject = false
      }
    },
    clickApprove () {
      this.comment = ''
      this.dialog = true
      this.workfor = this.mode === 'approve' ? 'approve' : 'acknowledge'
    },
    clickReject () {
      this.comment = ''
      this.dialog = true
      this.workfor = 'reject'
    },
    async updateStatusApprove (task, mode, comment) {
      const self = this
      var confirmList = []
      self.selected.forEach(e => {
        confirmList.push(
          {
            requestStatus: task,
            _id: e._id
          }
        )
      })
      await axios({
        url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/companys/updateStatusReqCompanyByToken`,
        method: 'POST',
        headers: {
          authorization: this.$store.state.token
        },
        data: {
          approveList: confirmList
        }
      })
        .then((response) => {
          if (response.data.success === true) {
            // swal('สำเร็จ', 'ทำรายการเรียบร้อย', 'success', {
            //   button: false,
            //   timer: 2000
            // })
            this.dialog = false
            this.snackbar = true
            this.page = 1
            self.searchFilterData(self.filterData)
          } else {
            swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
              button: false,
              timer: 2000
            })
          }
        })
        .catch(function (thrown) {
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
        })
    },
    select (event) {
      this.checkAllowBtn()
    },
    selectAllToggle (props) {
      if (this.selected.length === 0) {
        this.selected = []
        const self = this
        props.items.forEach(item => {
          if (item.status === 'pending') {
            self.selected.push(item)
          }
        })
      } else this.selected = []
    }
  }
}
</script>

<style>
.v-data-table {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 16px;
}
.row-menu-left {
  justify-content: flex-start !important;
}
.row-menu-right {
  justify-content: flex-end !important;
}
.v-data-table tbody tr.v-data-table__expanded__content {
  box-shadow: inset 0px 4px 8px -5px rgba(50, 50, 50, 0), inset 0px -4px 8px -5px rgba(50, 50, 50, 0) !important;
}
.padding-left-90 {
  padding-left: 90px !important;
}
.table-name-row {
  display: flex;
  flex-direction: row;
}
.btn-edit-dep {
  background-color: #0370B7 !important;
  color: #fff !important;
}
.btn-del-dep {
  background-color: #da2525 !important;
  color: #fff !important;
}
</style>

<style scoped>

.table-approve >>> table > tbody > tr > td:nth-child(1),
.table-approve >>> table > thead > tr > th:nth-child(1) {
  position: sticky;
  position: -webkit-sticky;
  background: white;
  left: 0;
}

.table-approve >>> table > tbody > tr > td:nth-child(2),
.table-approve >>> table > thead > tr > th:nth-child(2) {
  position: sticky;
  position: -webkit-sticky;
  background: white;
  left: 56px;
}

.table-approve >>> table > tbody > tr > td:nth-child(3),
.table-approve >>> table > thead > tr > th:nth-child(3) {
  position: sticky;
  position: -webkit-sticky;
  background: white;
  left: 126px;
}

.table-approve >>> table > tbody > tr:hover > td:nth-child(1),
.table-approve >>> table > tbody > tr:hover > td:nth-child(2),
.table-approve >>> table > tbody > tr:hover > td:nth-child(3) {
  background: #eeeeee;
}

.table-approve >>> table > thead > tr > th:nth-child(1),
.table-approve >>> table > thead > tr > th:nth-child(2),
.table-approve >>> table > thead > tr > th:nth-child(3) {
  background-color: #F8F9FB;
}

.table-approve >>> table > tbody > tr.v-data-table__selected > td:nth-child(1),
.table-approve >>> table > tbody > tr.v-data-table__selected > td:nth-child(2),
.table-approve >>> table > tbody > tr.v-data-table__selected > td:nth-child(3) {
  background: #f7f7f7;
}

.table-approve >>> table > tbody > tr.v-data-table__selected:hover > td:nth-child(1),
.table-approve >>> table > tbody > tr.v-data-table__selected:hover > td:nth-child(2),
.table-approve >>> table > tbody > tr.v-data-table__selected:hover > td:nth-child(3) {
  background: #eeeeee;
}
</style>
